import UploadTRCT from "./components/UploadTRCT";
import AuthProvider from "./components/AuthProvider"; 
import React from "react";

export default function App() {
  return (
    <AuthProvider>
      <UploadTRCT />
    </AuthProvider>
  );
}

